import { useContext } from 'react';
import { ArrayFieldStateContext } from '../Context.js';

function useArrayFieldState() {
  return useContext(ArrayFieldStateContext);
}

export { useArrayFieldState };
